<div class="ovoo">
    <div class="container mt-5">
        <div class="row justify-content-center"><span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq">ᠨᠣᠮ ᠤᠨ ᠣᠪᠣᠭ᠎ᠠ</h4><span class="col lpat"></span></div>
        <div class="row intro mb-5 position-relative overflow-hidden" style="background: url({{ibg}}) no-repeat;"><a href="http://nomiinoboo.com/3Dshuaobao/3D/" class="ovoo3d mgl fqg f18">3D ᠨᠣᠮ ᠤᠨ ᠣᠪᠣᠭ᠎ᠠ ᠶᠢ ᠦᠵᠡᠬᠦ</a>
            <p class="mgl fqg f20 p-5 m-0 overflow-auto">
                {{introduce.content}}
            </p>
        </div>
        <div class="row justify-content-center"><span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq"> ᠣᠪᠣᠭᠠᠨ ᠡᠵᠡᠳ</h4><span class="col lpat"></span></div>
        <div class="row oe ba" *ngFor="let im of master">
            <img alt="阿拉腾毕力格" class="img-thumbnail p-2 mb-5" src="{{url + im.image}}">
            <p class="mgl fqg f18 mb-5">
                <span class="f22 mb-3">{{im.title}}</span> {{im.content}}
            </p>
        </div>
        <div class="row justify-content-center"><span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq" style="line-height: 36px;"> ᠨᠣᠮ ᠤᠨ ᠣᠪᠣᠭᠠᠨ ᠤ ᠰᠢᠷᠢᠰ ᠠᠵᠢᠯᠯᠠᠭ᠎ᠠ </h4><span class="col lpat"></span></div>
        <div class="row">
            <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-3" *ngFor="let sal of saList">
                <div class="date">{{sal.publishTime.slice(0,10)}}</div>
                <a class="position-relative d-block" href="video/{{sal.id}}">
                    <h5 class="title mgl fqg position-absolute w-100 m-0" style="height: 100%;">
                        <div>{{sal.title}}</div>
                    </h5><img alt="" class="img-thumbnail w-100 p-2" src="{{url + sal.mediaFiles[0].path}}"></a>
            </div>
        </div>
        <div class="row justify-content-center mt-5"><span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq"> ᠵᠠᠮ ᠤᠨ ᠵᠦᠭᠯᠡᠭᠦᠷ</h4><span class="col lpat"></span></div><iframe src="/assets/pos.html" height="440" class="location container mb-5"></iframe></div>
</div>